import { DateStrategyAssign } from "app/shared/model/EditPricelist";
import { DateStrategy } from "app/shared/model/EditProductOffering";
import { cloneDeep } from "app/pages/PricelistNew/components/utils/cloneDeep";

export const switchStrategyType = (
    current: DateStrategyAssign,
    nextTypeId: number,
    offeringToDate?: string | null
): DateStrategyAssign => {
    if (current.strategyTypeId === nextTypeId) {
        return current;
    }

    const next = cloneDeep(current);
    next.strategyTypeId = nextTypeId;
    next.recurranceStartDays = [];
    next.specificStartDates = [];
    next.fixedDurationDates = [];
    next.lastStartDate = null as any;

    if (DateStrategy[nextTypeId] === "Offering Dates") {
        next.toDate = (offeringToDate || next.toDate) as any;
    } else if (DateStrategy[nextTypeId] === "Fixed Duration") {
        next.toDate = null;
    }

    return next;
};